module.exports = __webpack_public_path__ + "static/ambient-7b8238d7bc085b35137a8d734e7b3e0b.mp3";